import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { PATHS } from '../common/constants';
import ForgotPassword from '../pages/ForgotPassword';
import { SignIn } from '../pages/SignIn';
import activate from '../pages/Activate';
import ConfirmEmailChange from '../pages/ConfirmEmailChange/ConfirmEmailChange';
import MagicLinkSignedOutServiceRequest from '../pages/MagicLinkSignedOutServiceRequest/MagicLinkSignedOutServiceRequest';
import ResetPassword from 'src/pages/ResetPassword/ResetPassword';

const PublicRoutes = () => {
  return (
    <Switch>
      <Route path={PATHS.AUTH_SIGN_IN} component={SignIn} />
      <Route path={PATHS.AUTH_FORGOT_PASSWORD} component={ForgotPassword} />
      <Route path={PATHS.AUTH_RESET_PASSWORD} component={ResetPassword} />
      <Route path={PATHS.AUTH_ACTIVATE} component={activate} />
      <Route
        path={PATHS.AUTH_CONFIRM_EMAIL_CHANGE}
        component={ConfirmEmailChange}
      />
      <Route
        path={PATHS.SERVICE_REQUESTS_VIEW}
        component={MagicLinkSignedOutServiceRequest}
      />
      <Route path="/">
        <Redirect to={PATHS.AUTH_SIGN_IN} />
      </Route>
    </Switch>
  );
};

export default PublicRoutes;
